module.exports = __webpack_public_path__ + "static/media/Entrance1.76e78a21.jpg";